import { render } from "./user.vue?vue&type=template&id=dac87de0&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"

import "./user.vue?vue&type=style&index=0&id=dac87de0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dac87de0"

export default script